import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./ScheduleConsultation.css";
import Heading from "../../../utls/Heading";

const ScheduleConsultation = () => {
  return (
    <>
      <div className="container Schedule-Consultation">
        <div className="row px-lg-3">
          <div className="col-md-7 col-12">
            <Heading className="headings ">
              <span>Why</span> Book a Consultation with Us
              <span style={{ fontWeight: "bold", color: "black" }}>?</span>
            </Heading>
            <p className="mt-3">
              Ready for a seamless business trip? Leave city travel worries
              behind with Blueberry Travel, your partner in creating
              personalized travel programs that match your company’s unique
              needs and goals.
            </p>

            <div className="d-flex mt-lg-5 mt-md-4">
              <LazyLoadImage
                src="https://blueberrywebsites.azureedge.net/bbt/images/Consult1.png"
                alt=""
                loading="lazy"
              />
              <div className="d-flex flex-column">
                <h5 className="fw-bold">Personalized Travel Solutions</h5>
                <p className="grps-p">
                  Get travel planning that’s as unique as your business. Our
                  personalized approach guarantees every detail of your journey
                  is aligned with your company’s objectives.
                </p>
              </div>
            </div>
            <div className="d-flex">
              <LazyLoadImage
                src="https://blueberrywebsites.azureedge.net/bbt/images/Consulot2.png"
                alt=""
                loading="lazy"
                className="consult1"
              />
              <div className="d-flex flex-column">
                <h5 className="fw-bold">Smart Cost Savings</h5>
                <p className="grps-p">
                  Maximize your travel budget with our innovative cost-saving
                  strategies. We always ensure you receive top-tier service
                  without sacrificing quality or convenience.
                </p>
              </div>
            </div>
            <div className="d-flex">
              <LazyLoadImage
                src="https://blueberrywebsites.azureedge.net/bbt/images/Consult3.png"
                alt=""
                loading="lazy"
                className="consult1"
              />
              <div className="d-flex flex-column">
                <h5 className="fw-bold">Exceptional Travel Experience</h5>
                <p className="grps-p">
                  Enjoy a seamless travel experience from start to end. We take
                  care of every detail, providing a journey that is efficient
                  and enjoyable to you.
                </p>
              </div>
            </div>
            <div className="d-flex">
              <LazyLoadImage
                src="https://blueberrywebsites.azureedge.net/bbt/images/Consult4.png"
                alt=""
                loading="lazy"
                className="consult1"
              />
              <div className="d-flex flex-column">
                <h5 className="fw-bold">Expert Compliance Guidance</h5>
                <p className="grps-p">
                  Navigate the complexities of travel regulations with ease. Our
                  expert guidance ensures all your trips match industry
                  standards, giving you peace of mind.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-5 d-md-block d-none">
            <div className="schedule-boy-img d-flex justify-content-xxl-center justify-content-lg-end">
              <LazyLoadImage
                src="https://blueberrywebsites.azureedge.net/bbt/images/scheduleboy.png"
                alt=""
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ScheduleConsultation;
